import React from 'react';
import Link from 'next/link';
import { POLICY_URL, PRIVACY_URL, SUPPORT_URL } from '~/constants';
const PolicyLinks = () => <div className={linkWrapperCss}>
    <Link href={POLICY_URL} target="_blank" id="policy-link">
      Quy chế hoạt động sàn
    </Link>
    <div />
    <Link href={PRIVACY_URL} target="_blank" id="privacy-link">
      Chính sách bảo mật
    </Link>
    <div />
    <Link href={SUPPORT_URL} target="_blank" id="support-link">
      Liên hệ hỗ trợ
    </Link>
  </div>;
const linkWrapperCss = "l1j2xuoh";
export default PolicyLinks;

require("./PolicyLinks.linaria.module.css");